import { Group } from '@mantine/core';
import type { Target } from '../../../api/targets-client/targets-client.type';
import { primaryBase, skyDark } from '../../../styles/design-tokens';
import { TableColumn } from '../../data-management/components/table';
import { getTargetComparisonSymbol, getTargetScope, getTimeAllocationTypeLabel } from './targets.helpers';

const TargetsTableColumns: TableColumn<Target>[] = [
  {
    key: 'name' as keyof Target,
    label: 'Target Name',
    width: '25%',
    sortable: true,
    render: (_: unknown, target: Target) => (
      <Group gap="xs">
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: target.is_active ? primaryBase : skyDark,
          }}
        />
        {target.name || '-'}
      </Group>
    ),
  },
  {
    key: 'measure' as keyof Target,
    label: 'Measure',
    width: '15%',
    sortable: true,
  },
  {
    key: 'target_value' as keyof Target,
    label: 'Target Value',
    width: '15%',
    sortable: true,
    render: (_: unknown, target: Target) =>
      `${getTargetComparisonSymbol(target.target_comparison, target.target_value, target.target_value_upper)}`,
  },
  {
    key: 'start_date' as keyof Target,
    label: 'Start Date',
    width: '15%',
    sortable: true,
    render: (_: unknown, target: Target) => new Date(target.start_date).toLocaleDateString(),
  },
  {
    key: 'end_date' as keyof Target,
    label: 'End Date',
    width: '15%',
    sortable: true,
    render: (_: unknown, target: Target) => (target.end_date ? new Date(target.end_date).toLocaleDateString() : '-'),
  },
  {
    key: 'repeat' as keyof Target,
    label: 'Repeat',
    width: '15%',
    sortable: false,
    render: (_: unknown, target: Target) =>
      target.is_work_period_target ? 'Every Sprint' : (getTimeAllocationTypeLabel(target.time_allocation_type) ?? '-'),
  },
  {
    key: 'id' as keyof Target,
    label: 'Scope',
    width: '15%',
    sortable: false,
    render: (_: unknown, target: Target) => {
      return getTargetScope(target);
    },
  },
];

export { TargetsTableColumns };
